import { create } from 'zustand';

interface ManageEmailNotifyModalState {
  objectSlug: string;
  mct_receive_messages: boolean;
  srbm_receive_messages: boolean;
  smst_receive_messages: boolean;
  srst_receive_messages: boolean;
  mct_count: number;
  srbm_count: number;
  smst_count: number;
  srst_count: number;
  availableChannels: string[];
  isOpen: boolean;
  onManageEmailNotifyModalClose: () => void;
  onManageEmailNotifyModalOpen: (
    objectSlug: string,
    mct_receive_messages: boolean,
    srbm_receive_messages: boolean,
    smst_receive_messages: boolean,
    srst_receive_messages: boolean,
    mct_count: number,
    srbm_count: number,
    smst_count: number,
    srst_count: number,
    availableChannels: string[],
  ) => void;
}

export const useManageEmailNotifyModalStore = create<ManageEmailNotifyModalState>(set => ({
  objectSlug: '',
  mct_receive_messages: false,
  srbm_receive_messages: false,
  smst_receive_messages: false,
  srst_receive_messages: false,
  mct_count: 0,
  srbm_count: 0,
  smst_count: 0,
  srst_count: 0,
  availableChannels: [],
  isOpen: false,
  onManageEmailNotifyModalClose: () => set({ isOpen: false, objectSlug: '' }),
  onManageEmailNotifyModalOpen: (
    objectSlug: string,
    mct_receive_messages: boolean,
    srbm_receive_messages: boolean,
    smst_receive_messages: boolean,
    srst_receive_messages: boolean,
    mct_count: number,
    srbm_count: number,
    smst_count: number,
    srst_count: number,
    availableChannels: string[],
  ) =>
    set({
      isOpen: true,
      objectSlug,
      mct_receive_messages,
      srbm_receive_messages,
      smst_receive_messages,
      srst_receive_messages,
      mct_count,
      srbm_count,
      smst_count,
      srst_count,
      availableChannels,
    }),
}));
